import React, { useState } from "react";
import Layout from "Layout";
import { Redirect, Route, useRouteMatch } from "react-router-dom";
import Home from "./Home";
import Single from "./Single";
import CreatePrice from "./CreatePrice";

type Propts={
  application?: string;
}

export default function Pricing({application}: Propts) {
  const match = useRouteMatch();
  
  return (
    <>
      <Layout pageTitle="Pricing">
        <>
          <Route path={`${match.path}/home`} render={() => <Home />} />

          <Route
            path={`${match.path}/overview`}
            exact
            render={() => <Single />}
          />

          <Route
            path={`${match.path}/overview/:id`}
            render={() => <Single />}
          />

          <Route
            path={`${match.path}/add-new`}
            exact
            render={() => <CreatePrice />}
          />
          {match.isExact && <Redirect to={`${match.url}/home`} />}
        </>
      </Layout>
    </>
  );
}
